var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgRussia = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 42",
    style: {
      enableBackground: "new 0 0 64 42"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.ru_st0{fill:#FFFFFF;}\n\t.ru_st1{fill:#F10000;}\n\t.ru_st2{fill:#0000FF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "black",
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rounded_Rectangle_7_copy_1_",
    className: "ru_st0",
    d: "M5.8,0h52.3C61.4,0,64,2.6,64,5.7v30.6c0,3.2-2.6,5.7-5.8,5.7H5.8 C2.6,42,0,39.4,0,36.3V5.7C0,2.6,2.6,0,5.8,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ru_st1",
    d: "M0,36.3C0,39.4,2.6,42,5.8,42h52.4c3.2,0,5.8-2.5,5.8-5.7V14H0V36.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 14,
    className: "ru_st2",
    width: 64,
    height: 14
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRussia, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Russia.1a36050c.svg";
export { ForwardRef as ReactComponent };